module.exports = __webpack_public_path__ + "img/08.8addbb39.png";